@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.bulk-errors-and-warning-modal {
  min-height: 300px;
}

.bulk-errors-and-warning-modal-body {
  padding: 15px;
  min-height: 250px;
}

.no-errors-message {
  height: 250px;
  color: @bulk-errors-and-warnings-modal--no-errors--text-color;
  font-size: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.error-or-warning {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.bulk-errors-and-warning-modal-footer {
  > button {
    margin-left: 10px;
  }
}
